import styles from "@/pages/saleOperations/saleWorkBench/customerDetail/index.module.less";
import classNames from "classnames";
import {getSalesTemplateList} from "@/services/saleOpServices.ts";
import {useContext, useEffect, useState} from "react";
import ClueDetailContext from "@/pages/clueManage/clueDetail/clueDetailContext.ts";
import {useParams, useSearchParams} from "react-router-dom";

const NodeSteps = (props) => {
  const {trackDetail, isReload} = props;
  const {detailState} = useContext(ClueDetailContext)
  const [search] = useSearchParams()
  const saleClueId = search.get('saleClueId')
  const [nodes, setNodes] = useState([])

  useEffect(() => {
    if (saleClueId) {
      trackDetail.salesTemplateId && detailState.salesTemplateId && getNodes()
    } else {
      (detailState.salesTemplateId || detailState.templateStepId) && getNodes()
    }
  }, [saleClueId, detailState.salesTemplateId, trackDetail.salesTemplateId, isReload, detailState.templateStepId]);

  useEffect(() => {
    console.log(
        detailState.templateStepId, 22
    )
  }, [ detailState.templateStepId]);

  const getNodes = () => {
    const {salesTemplateId, currentNodeId, currentTemplateStepId, templateStepId} = detailState
    console.log(!saleClueId, detailState.status, templateStepId, salesTemplateId)

    // DESIGN状态必定产生商机
    if (!saleClueId && detailState.status === 'DESIGN' && !templateStepId) {
      return;
    }
    // TO_SHOP状态 不一定产生商机
    if (!saleClueId && detailState.status === 'TO_SHOP' && !templateStepId && !salesTemplateId) {
      return;
    }
    console.log('reloadNode!!!')
    getSalesTemplateList({
      orderBys: [
        {
          columnName: "ID",
          asc: true
        }
      ],
      salesTemplateId: saleClueId ? trackDetail.salesTemplateId : detailState.status === 'DESIGN' ? templateStepId : (templateStepId || salesTemplateId)
    }).then(res => {
      const currentNodeIndex = res.findIndex(item => item.id === (saleClueId ? trackDetail.currentNodeId : currentTemplateStepId || currentNodeId));
      const nodes = res.map((item, index) => ({...item,  isOk: index <= currentNodeIndex}))
      setNodes(nodes)
    })
  }

  return <>
    <div className={classNames([styles.nodeStepBox].concat(props.className))}>
      {nodes.map(item => <div key={item.id}
          className={classNames([styles.nodeStep].concat(item.isOk ? styles.nodeStepEnd : ''))}>
        <span className={item.isOk ? styles.icon_nodeEnd : styles.icon_node}/>
        {item.name}
      </div>)}
    </div>
  </>
}

export default NodeSteps
